module.exports = __webpack_public_path__ + "img/Row2Box3.08e349ec.svg";